<template>
	<div id="Expertthinkatnk" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/zjzk.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/zbtga.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>招标</span><span style="color:#D7230C;">通告</span></div>
					<div class="sm_pub">招标通告</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/zbgg">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;width: 100%;height: 370px;">
			<div style="width: 100%;height: 70px;">
				<div
					style="float: left;width: 20%;height: 70px;line-height: 70px;text-align: center;margin-left: 5%;font-size: 20px;font-weight: 800;">
					日期
				</div>
				<div
					style="float: left;width: 15%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
					项目类型
				</div>
				<div
					style="float: left;width: 15%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
					单位类型
				</div>
				<div
					style="float: left;width: 30%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
					招标采购标题
				</div>
				<!-- :to="{path: '/zbggdetail', query: {id:item.id,title:item.title}}" -->
			</div>
			<div @click="das(item.id,item.title)"
				style="width: 100%;height: 50px;margin-top: 10px;float: left;box-shadow: 0 4px 24px rgba(0,0,0,.16);"
				v-for="(item,index) in xptjlist" :key="index">
				<div
					style="float: left;width: 20%;height: 50px;line-height: 50px;text-align: center;font-size: 14px;margin-left: 5%;">
					{{getLocalTime(item.create_time)}}
				</div>
				<div style="float: left;width: 15%;height: 50px;line-height: 50px;text-align: center;font-size: 14px;">
					{{item.xm_type}}
				</div>
				<div style="float: left;width: 15%;height: 50px;line-height: 50px;text-align: center;font-size: 14px;">
					{{item.unit_type}}
				</div>
				<div style="float: left;width: 30%;height: 50px;line-height: 50px;text-align: center;font-size: 14px;white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;">
					{{item.title}}
				</div>
				<div style="float: left;width: 10%;height: 50px;line-height: 50px;text-align: center;">
					查看详情
				</div>
			</div>
		</div>
		<dashang ref="dashang"></dashang>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: ''
			}
		},
		components: {
			//打赏
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async das(id, sb) {
				// 	let that = this
				// 	const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				// 	this.sid = loginInfo.id
				// 	if (loginInfo) {
				// 		let res = await http.post('api/picture/login_yz', {
				// 			tid: id,
				// 			nologin_type: 'zbtg',
				// 			uid: loginInfo.id
				// 		})

				// 		console.log(res)
				// 		if (res.data.code == 500) {
				// 			this.$refs.dashang.DS_ck(20, '查看招标通告', 'zbtg', id)
				// 			// that.$refs.child.isShowZF = true //修改子组件data
				// 		} else {
				this.$router.push({
					path: `/zbggdetail?id=${id}&title=${sb},`
				})
				// 		}
				// 	} else {
				// 		this.$message.error('请先登录');
				// 		this.$router.replace('/login')
				// 	}
			},
		},
		async mounted() {
			let res = await http.post('api/picture/zbtg_index', {})
			// console.log(res)
			// let xpList = res.data.data.list
			// let newArr = [
			// 	[],
			// 	[],
			// ]
			// xpList.forEach((item, index) => {
			// 	if (index < 4) {
			// 		newArr[0].push(item)
			// 	} else if (index >= 4 && index < 8) {
			// 		newArr[1].push(item)
			// 	} 
			// })
			this.xptjlist = res.data.data.list.splice(0, 5)
			console.log(this.xptjlist)
		}
	}
</script>

<style>
	#Expertthinkatnk {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 头部 */
	#Expertthinkatnk .pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	#Expertthinkatnk .pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .img_logo>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	#Expertthinkatnk .title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	#Expertthinkatnk .imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	#Expertthinkatnk .imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	#Expertthinkatnk .sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	#Expertthinkatnk .ct_title {
		float: left;

	}

	#Expertthinkatnk .ct_img {
		float: left;
		margin-left: 10px;
	}

	#Expertthinkatnk .ct_img>img {
		width: 12px;
		height: 10px;
	}

	#Expertthinkatnk .ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */

	#Expertthinkatnk .z_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .lb_cont {
		float: left;
		width: calc((100% - 120px)/4);
		margin-left: 24px;
		height: 330px;
		border: 1px solid #ececec;
	}

	#Expertthinkatnk .list_lb_img {
		height: 250px;
	}

	#Expertthinkatnk .list_lb_img>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	#Expertthinkatnk .ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}

	#Expertthinkatnk /deep/.el-carousel__container {
		height: 350px;
		margin-top: 20px;
	}
</style>
